import { ONE_SECOND_MILLISECONDS } from '../../../dateTime';
import { KalturaProgramAssetLean } from '../../composed';
import { createOnDemandResponseProfile, createSearchAssetFilter } from '../../factories';
import { processPhoenixPrograms } from '../../processing';
import { fetchAssetList } from '../../services';

import { addNotFoundPrograms } from './addNotFoundPrograms';

type FetchChannelProgramsArgs = {
  channelId: number;
  endDate: number;
  startDate: number;
};

export async function fetchChannelPrograms({ channelId, endDate, startDate }: FetchChannelProgramsArgs) {
  const { objects } = await fetchAssetList<KalturaProgramAssetLean>({
    filter: createSearchAssetFilter({
      kSql: getKsql({ startDate, endDate, channelId }),
      orderBy: 'START_DATE_ASC',
    }),
    responseProfile: createOnDemandResponseProfile({ retrievedProperties }),
    allPages: true,
  });

  const programs = processPhoenixPrograms(objects, channelId);

  return addNotFoundPrograms({ programs, startDate, endDate, channelId });
}

const retrievedProperties = [
  'enableCatchUp',
  'enableCdvr',
  'enableStartOver',
  'enableTrickPlay',
  'endDate',
  'externalId',
  'description',
  'id',
  'images',
  'metas.Adult',
  'metas.EpisodeName',
  'metas.EpisodeNumber',
  'metas.Year',
  'metas.IsMosaicEvent',
  'metas.IsSeries',
  'metas.Popular',
  'metas.SeasonNumber',
  'metas.SeriesID',
  'name',
  'startDate',
  'tags.MosaicChannelsInfo',
  'tags.MosaicInfo',
  'tags.ParentalRating',
  'tags.SeriesName',
  'type',
].join(',');

type Params = {
  startDate: number;
  endDate: number;
  channelId: number;
};

function getKsql({ startDate, endDate, channelId }: Params) {
  const start = Math.floor(startDate / ONE_SECOND_MILLISECONDS);
  const end = Math.ceil(endDate / ONE_SECOND_MILLISECONDS);

  return [
    `(and linear_media_id:'${channelId}'`,
    `(and end_date > '${start}' start_date < '${end}')`,
    `asset_type='epg'`,
    `auto_fill=true)`,
  ].join(' ');
}
